import { PaginationQuery } from "../common";

export enum IntegrationLogStatus {
  Success = "success",
  Failed = "failed",
}

export enum IntegrationLogType {
  OrderValidate = "validate_order",
  OrderCreate = "order_create",
  OrderSubmit = "order_submit",
  OrderQuery = "order_query",
  OrderDelete = "order_delete",
  ShipmentReport = "shipment_edi_report",
  CustomerOrderSync = "customer_order_sync",
  CustomerOrderReport = "customer_order_report",
  BusinessOrderReport = "business_order_report",
  StockBatchCreatedReport = "stock_batch_created_report",
  StockBatchCompletedReport = "stock_batch_completed_report",
  StockInventorySync = "stock_inventory_sync",
  StockInventoryReport = "stock_inventory_report",
  StockInventoryMovementReport = "stock_inventory_movement_report",
}

export interface IntegrationLogVo {
  id: number;
  createdAt: string;
  updatedAt: string;
  type: IntegrationLogType;
  status: IntegrationLogStatus;
  log?: Record<string, unknown>;
  customerNumber?: string;
}

export type IntegrationLogSearchParams = Partial<PaginationQuery> & {
  typeList?: IntegrationLogType[];
  status?: IntegrationLogStatus;
  customerNumberLike?: string;
  customerNumber?: string;
  includeLog?: boolean;
};
